// src/components/RatingDisplay.js
import React from "react";
import "./RatingDisplay.css";

export default function RatingDisplay({ ratings, stats, loading }) {
  if (loading) {
    return (
      <div className="rating-display-loading">
        <div className="loading-spinner"></div>
        <p>Loading ratings...</p>
      </div>
    );
  }

  const { average_rating = 0, total_ratings = 0, rating_breakdown = {} } = stats || {};

  const getRatingPercentage = (starValue) => {
    if (total_ratings === 0) return 0;
    return ((rating_breakdown[starValue] || 0) / total_ratings) * 100;
  };

  return (
    <div className="rating-display-container">
      {/* Rating Summary */}
      <div className="rating-summary">
        <div className="rating-summary-main">
          <div className="rating-score">
            {average_rating.toFixed(1)}
          </div>
          <div className="rating-stars-display">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                className={`star-icon ${star <= Math.round(average_rating) ? "filled" : ""}`}
              >
                ⭐
              </span>
            ))}
          </div>
          <div className="rating-count">
            Based on {total_ratings} {total_ratings === 1 ? "review" : "reviews"}
          </div>
        </div>

        {/* Rating Breakdown */}
        {total_ratings > 0 && (
          <div className="rating-breakdown">
            {[5, 4, 3, 2, 1].map((star) => (
              <div key={star} className="rating-bar-row">
                <span className="rating-bar-label">{star} ⭐</span>
                <div className="rating-bar-container">
                  <div
                    className="rating-bar-fill"
                    style={{ width: `${getRatingPercentage(star)}%` }}
                  ></div>
                </div>
                <span className="rating-bar-count">
                  {rating_breakdown[star] || 0}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Individual Ratings */}
      {ratings && ratings.length > 0 ? (
        <div className="rating-reviews-section">
          <h3 className="rating-reviews-title">Reviews</h3>
          <div className="rating-reviews-list">
            {ratings.map((rating) => (
              <div key={rating.id} className="rating-review-card">
                <div className="rating-review-header">
                  <div className="rating-review-user">
                    <div className="rating-review-avatar">
                      {rating.rater?.avatar ? (
                        <img src={rating.rater.avatar} alt={rating.rater.name} />
                      ) : (
                        <span className="rating-review-avatar-text">
                          {rating.rater?.name?.charAt(0).toUpperCase() || "?"}
                        </span>
                      )}
                    </div>
                    <div className="rating-review-info">
                      <div className="rating-review-name">{rating.rater?.name}</div>
                      <div className="rating-review-role">
                        {rating.rater?.role === "agency" ? "Travel Agency" : "Travel Partner"}
                      </div>
                    </div>
                  </div>
                  <div className="rating-review-rating">
                    {[...Array(5)].map((_, index) => (
                      <span
                        key={index}
                        className={`star-small ${index < rating.rating ? "filled" : ""}`}
                      >
                        ⭐
                      </span>
                    ))}
                  </div>
                </div>
                {rating.feedback_message && (
                  <div className="rating-review-feedback">
                    "{rating.feedback_message}"
                  </div>
                )}
                <div className="rating-review-date">
                  {new Date(rating.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        total_ratings === 0 && (
          <div className="rating-no-reviews">
            <div className="rating-no-reviews-icon">⭐💬</div>
            <h3>No Reviews Yet</h3>
            <p>Be the first to share your experience!</p>
          </div>
        )
      )}
    </div>
  );
}
